var render = function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 28 28"}},[_c('g',{attrs:{"fill":"#DE3C4B","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"28","height":"2","y":"13","rx":"1","transform":"rotate(45 14 14)"}}),_c('rect',{attrs:{"width":"28","height":"2","y":"13","rx":"1","transform":"rotate(135 14 14)"}})])]) };
module.exports = { render: render };


//////////////////
// WEBPACK FOOTER
// ./assets/_img/icons/close.svg
// module id = 155
// module chunks = 0